import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { avatarImageStyles } from './styles/avatar-image.styles';
import type { AvatarImagePropsInterface } from './types/avatar-image.types';

/**
 * @since 10.0.0
 */
export const AvatarImage = forwardRef<HTMLImageElement, AvatarImagePropsInterface>(
  (props: AvatarImagePropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;

    const styles = css(avatarImageStyles, cssProp);

    const Component = asChild ? Slot : 'img';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Avatar.Image"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

AvatarImage.displayName = 'Avatar.Image';
